import type { Topic } from '@/types/topic';
import type { DisplaySection } from '@/api/displaySections';

export type FieldKind = 'flyer' | 'attachment' | 'schedule' | 'reference';

/** type_id → display name. Mirrors backend topic-types.js. */
export const CONTENT_TYPE_NAME: Record<number, string> = {
  1: 'Message', 2: 'Meeting', 3: 'Program', 4: 'Mix',
  5: 'Question', 6: 'Support', 7: 'Information',
};

/** Which type-specific field editor(s) a content type shows. */
export function fieldKindsForType(typeId: number): FieldKind[] {
  switch (typeId) {
    case 3: return ['flyer'];       // Program
    case 1: return ['attachment'];  // Message
    case 2: return ['schedule'];    // Meeting
    default: return ['reference'];  // Mix / Question / Support / Information
  }
}

const secIds = (t: Topic): number[] => (t.display_sections ?? []).map((s) => s.id);

export function topicsInSection(topics: Topic[], sectionId: number): Topic[] {
  return topics.filter((t) => secIds(t).includes(sectionId));
}
export function sectionCount(topics: Topic[], sectionId: number): number {
  return topicsInSection(topics, sectionId).length;
}
export function allowedTypeIdsForSection(sections: DisplaySection[], sectionId: number): number[] {
  return sections.find((s) => s.id === sectionId)?.allowed_type_ids ?? [];
}
